import { Button, IconButton, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionButton = styled(IconButton)(({ theme }) => ({
    width: '24px',
    height: '24px',
    borderRadius: '8px',
    backgroundColor: '#EBEFED',
    color: '#3a6647',

    '&:hover': {
        backgroundColor: '#f5f5f5',
        borderColor: '#3a6647'
    },
    '&:disabled': {
        backgroundColor: '#fafafa',
        borderColor: '#e0e0e0'
    }
}));

export const NumberInput = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '& input': {
            textAlign: 'center',
            padding: '8px',
            fontSize: '14px',
            fontWeight: 500
        }
    }
}));

// export const PeriodButton = styled.button`
//     padding: 6px 16px;
//     border-radius: 4px;
//     border: none;
//     font-size: 14px;
//     cursor: pointer;
//     font-weight: 500;
//     transition: all 0.2s ease;
//     background-color: #e0e0e0;
//     color: #333333;

//     &:hover {
//         background-color: #535353;
//         color: #ffffff;
//     }

//     &.active {
//         background-color: #7c8187;
//         color: #ffffff;
//     }

//     &:disabled {
//         color: #999999;
//         cursor: not-allowed;
//     }
// `;

export const PeriodButton = styled(Button)(({ theme }) => ({
    minWidth: '100px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#e0e0e0',
    color: '#333333',
    fontWeight: 700,
    textTransform: 'none',

    '&:hover': {
        backgroundColor: '#535353',
        color: '#ffffff'
    },
    '&.active': {
        backgroundColor: '#7c8187',
        color: '#ffffff'
    },
    '&:disabled': {
        backgroundColor: '#fafafa',
        borderColor: '#e0e0e0',
        color: '#999'
    }
}));

export const CancelButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    color: '#666',
    borderColor: '#e0e0e0',
    '&:hover': {
        borderColor: '#999',
        backgroundColor: '#f5f5f5'
    }
}));

export const SaveButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    backgroundColor: '#3a6647',
    '&:hover': {
        backgroundColor: '#2d5038'
    },
    '&:disabled': {
        backgroundColor: '#e0e0e0',
        color: '#999'
    }
}));
